export default {"src":"/_next/static/media/Question-Icon.19d14654.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};